import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProfessionalBelagomSidebar, BELAGOM_SIDEBAR_ITEMS, type BelagomView } from './ProfessionalBelagomSidebar';
import { ZijMenuMobielKnop, PaginaKop } from './ZijMenu';

interface ProfessionalBelagomLayoutProps {
  children: React.ReactNode;
  activeView: BelagomView;
  onViewChange: (view: BelagomView) => void;
}

export const ProfessionalBelagomLayout: React.FC<ProfessionalBelagomLayoutProps> = ({
  children,
  activeView,
  onViewChange,
}) => {
  const { t } = useTranslation('common');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const item = BELAGOM_SIDEBAR_ITEMS.find((i) => i.view === activeView) ?? BELAGOM_SIDEBAR_ITEMS[0];

  return (
    <div>
      <ZijMenuMobielKnop onClick={() => setSidebarOpen(true)} />
      <div className="max-w-7xl mx-auto flex h-[calc(100vh-4rem)] overflow-hidden">
        <ProfessionalBelagomSidebar
          activeView={activeView}
          onViewChange={onViewChange}
          mobileOpen={sidebarOpen}
          onMobileClose={() => setSidebarOpen(false)}
        />
        <div className="flex-1 min-w-0 overflow-y-auto">
          {/* Paginatitel in de inhoudskolom (merkstijl okt 2026) */}
          <PaginaKop
            titel={t(`belagomSidebar.${item.view}`, { defaultValue: item.label })}
            ondertitel={item.description}
            className="px-4 sm:px-8 pt-6"
          />
          <div className="py-6 px-4 sm:px-8">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
